import { nonChargeable } from './studentLifecycle';
// Calendar rules use Kolkata dates; no historical receipt is rewritten.
const dayOf = value => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? new Date(date.getTime() + 330 * 60000).toISOString().slice(0, 10) : '';
};
const isMonth = value => typeof value === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
function shiftMonth(month, count) {
  if (!isMonth(month)) return '';
  const date = new Date(`${month}-01T00:00:00Z`);
  date.setUTCMonth(date.getUTCMonth() + count);
  return date.toISOString().slice(0, 7);
}
function firstChargeableMonth(student = {}) {
  const join = dayOf(student.joinDate);
  const earliest = join ? shiftMonth(join.slice(0, 7), Number(join.slice(8)) > 18 ? 1 : 0) : '';
  const agreed = isMonth(student.firstChargeableMonth) ? student.firstChargeableMonth : '';
  const regularStart = isMonth(student.monthlyStartMonth) ? student.monthlyStartMonth : '';
  return [earliest, agreed, regularStart].filter(Boolean).sort().pop() || '';
}
function monthlyFine(month, paidAt) {
  const day = dayOf(paidAt);
  if (!isMonth(month) || !day) return { days: 0, amount: 0 };
  const next = shiftMonth(month, 1);
  const end = new Date(new Date(`${next}-01T00:00:00Z`).getTime() - 86400000).toISOString().slice(0, 10);
  const last = day < end ? day : end;
  const days = Math.max(0, Math.floor((new Date(`${last}T00:00:00Z`) - new Date(`${month}-12T00:00:00Z`)) / 86400000));
  return { days, amount: days * 20 };
}
function unpaidFeeMonths(student, paidMonths, admissionDate, targetMonth, asOf) {
  const start = firstChargeableMonth(student);
  const day = dayOf(asOf);
  if (!start || !day || !isMonth(targetMonth)) return { unknown: true, months: [], inGrace: false };
  const cutoff = [targetMonth, day.slice(0, 7)].sort()[0];
  const admission = dayOf(admissionDate);
  const graceEnd = admission ? shiftMonth(admission.slice(0, 7), 2) : '';
  if (cutoff < start || (graceEnd && cutoff < graceEnd)) return { unknown: false, months: [], inGrace: true };
  const months = [];
  for (let month = start; month <= cutoff; month = shiftMonth(month, 1)) {
    if (!paidMonths.has(month) && !nonChargeable(student, month)) months.push(month);
  }
  return { unknown: false, months, inGrace: false };
}
export { firstChargeableMonth, monthlyFine, unpaidFeeMonths, shiftMonth };
